angular.module('bmsApp.trugreen.job').factory('TGChemicalRecordSvc', function (CRUDSvc, $modal, $rootScope) {

	var self = {
		showChemicalRecordModal: function(tgTreatment, tgProduct) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/job/templates/ChemicalRecordModal.html',
				controller: 'TGChemicalRecordModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					tgTreatment: function () {
						return angular.copy(tgTreatment);
					},
					tgProduct: function () {
						return angular.copy(tgProduct);
					}
				}
			});

			return modalInstance.result;
		}
	};
	return self;

});
